import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { useResponsive } from '../../hooks/useResponsive'
import NavPC from './NavPC'
import NavSP from './NavSP'

export type NavProps = BoxProps & {}

const Nav: React.FC<NavProps> = ({ ...others }) => {
  const isPC = useResponsive(false, true)
  return (
    <>
      <Box pos="fixed" w="100%" minW={['0', 'contentMinWPC']} {...others}>
        {isPC ? <NavPC /> : <NavSP />}
      </Box>
    </>
  )
}

export default Nav
